/// Notification
// Props:
// icon - component - pass component for icon
// iconstyle - (warn, danger, info, success) - passed into style for icon
// topic - text - shown as title of notification
// children are passed as content
// other props are passed to wrapper

import classes from './Notification.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Notification(props) {
    let iconclass = "";
    switch (props.iconstyle) {
        case "warn":
            iconclass = classes.warn
            break;
        case "danger":
            iconclass = classes.danger
            break;
        case "info":
            iconclass = classes.info
            break;
        case "success":
            iconclass = classes.success
            break;
        default:
            break;
    }

    return (
        <div className={classes.wrapper} {...props}>
            <div style={{ display: "flex", alignContent: "center" }}>
                <FontAwesomeIcon className={iconclass} style={{ marginRight: "20px", marginLeft: "10px", marginTop: "auto", marginBottom: "auto" }} icon={props.icon} />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div className={classes.title}>
                    {props.topic}
                </div>
                <div className={classes.content}>
                    {props.children}
                </div>
            </div>
        </div>
    )
}